import { Expose } from "class-transformer";
import { LimitedPermission } from "@altertec_gparn/lib";

export class UpdateApiTokenDto {
  @Expose()
  id: string;

  @Expose()
  name: string;

  @Expose()
  permissions: LimitedPermission[];

  @Expose()
  userId: string;
}
